import { getScheduleEmployeeService } from "../../services/gets";
import { v4 as uuidv4 } from "uuid";

// Convert 24h format (HH:MM) to 12h format (HH:MM AM/PM)
const convertTo12HFormat = (time24h: string): string => {
  if (!time24h || time24h === "") return "";

  const [hoursStr, minutesStr] = time24h.split(":");
  let hours = parseInt(hoursStr, 10);
  const minutes = minutesStr || "00";

  const period = hours >= 12 ? "PM" : "AM";

  // Convert hours to 12h format
  if (hours === 0) {
    hours = 12; // Midnight
  } else if (hours > 12) {
    hours = hours - 12;
  }

  const hoursFormatted = hours.toString().padStart(2, "0");
  return `${hoursFormatted}:${minutes} ${period}`;
};

export const getEmployeeSchedulesAdapter = async (idEmployee: number) => {
  const response: IResponse = await getScheduleEmployeeService(idEmployee);

  if (!response.isSuccess) {
    return {
      ...response,
      data: [],
    };
  }

  const separateScheduleByDays = () => {
    const daysMap = new Map();

    // Initializes an array with the names of the days of the week
    const daysOfWeek = [
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado",
      "Domingo",
    ];

    // Fills the map with all the days of the week with default schedules
    // Using default times (08:00 AM - 06:00 PM) so the SchedulesWrapper can generate time options
    daysOfWeek.forEach((dayName, index) => {
      daysMap.set(dayName, [
        {
          startTime: "08:00 AM",
          endTime: "06:00 PM",
          idSchedule: "static" + uuidv4(),
          isAvailable: false,
        },
      ]);
    });

    // Fills the map with the obtained schedules
    response.data.forEach((schedule) => {
      const { dayOfTheWeek, startTime, endTime, idSchedule, activeBit } =
        schedule;
      const dayName = daysOfWeek[dayOfTheWeek - 1];

      if (!dayName) {
        return; // Ignores unknown days
      }

      if (!daysMap.has(dayName)) {
        daysMap.set(dayName, []);
      }

      // Remove default "static" schedule if we have real data from backend
      const currentSchedules = daysMap.get(dayName);
      const staticScheduleIndex = currentSchedules.findIndex((s) =>
        String(s.idSchedule).includes("static")
      );
      if (staticScheduleIndex !== -1) {
        currentSchedules.splice(staticScheduleIndex, 1);
      }

      // Push the new schedule (convert 24h to 12h format)
      daysMap.get(dayName).push({
        startTime: convertTo12HFormat(startTime),
        endTime: convertTo12HFormat(endTime),
        idSchedule: idSchedule,
        isAvailable: activeBit === 1,
      });

      // Sort the schedules by startTime
      daysMap.get(dayName).sort((a, b) => {
        return (
          new Date("1970/01/01 " + a.startTime).getTime() -
          new Date("1970/01/01 " + b.startTime).getTime()
        );
      });
    });

    //@ts-ignore
    const scheduleByDays = [...daysMap.entries()].map(
      ([day, scheduleList], idDay) => ({
        idDay,
        day,
        scheduleList,
      })
    );

    return scheduleByDays;
  };

  const schedules = separateScheduleByDays();

  return {
    ...response,
    data: schedules,
  };
};
